import React from "react";
import image from "../../Images/img/Component 3-5.png";
// replace paths as needed
import ctaIcon1 from "../../Images/img/Component 3-9.png";
import ctaIcon2 from "../../Images/img/Component 3-10.png";
import { Link } from "react-router-dom";
import CalendlyButton from "../Shared/CalendlyButton";
const FreeConsultation = () => {
  return (
    <div className="service1 sp sec-bg1 m-8">
      <div className="max-w-7xl mx-auto px-0 md:px-4">
        <div className="flex justify-center">
          {/* Card */}
          <div
            className="
              relative w-full md:w-1/2 lg:w-1/2
              p-6 py-14 text-center
              rounded-2xl
              bg-gradient-to-br from-[#0b2b40] via-[#0f0f0f] to-[#001839]
              shadow-[0_30px_80px_rgba(0,0,0,0.6)]
              border border-white/10
              overflow-hidden
            "
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay="300"
          >
            {/* Glow effect */}
            <div className="absolute -top-20 -right-20 w-60 h-60 bg-green-400/20 blur-3xl rounded-full"></div>

            {/* Badge */}
            <span className="inline-block mb-3 px-4 py-1 text-xs font-semibold rounded-full bg-gray-400 text-black">
              Kostenlos & unverbindlich
            </span>

            <h2 className="h2-mb h2-md h2-lg h2-2xl !text-white ">
              KOSTENLOSE <br /> Beratung
            </h2>

            <p className="mt-2 text-gray-300 text-sm">
              Teile deine Ideen mit uns – wir analysieren sie gemeinsam
            </p>

            {/* Checklist */}
            <ul className="mt-6 text-sm text-gray-300 space-y-2">
              <li className="flex justify-left md:justify-center gap-2">
                <span className="text-yellow-400">
                  <img src={image} alt="" />
                </span>
                Wie viele Seiten werden benötigt?
              </li>
              <li className="flex justify-left md:justify-center gap-2">
                <span className="text-yellow-400">
                  <img src={image} alt="" />
                </span>
                Mehrsprachig oder nur Deutsch?
              </li>
              <li className="flex justify-left md:justify-center gap-2">
                <span className="text-yellow-400">
                  <img src={image} alt="" />
                </span>
                Besondere Funktionen oder Integrationen?
              </li>
            </ul>

            {/* Buttons */}
            <div className="flex flex-col justify-center items-center mt-8 gap-3">
              {/* CALL BUTTON */}
              <Link
                to="tel:+491234567890" // 👉 put your real number here
                className="
      flex items-center gap-3 px-6 py-3
      rounded-[8px]
      bg-white text-black
      font-semibold text-xs
      shadow-lg
      hover:shadow-white-400/40
      hover:-translate-y-1
      transition-all duration-300
      w-fit
    "
              >
                    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ marginRight: "8px" }}
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.89.32 1.76.59 2.59a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.49-1.11a2 2 0 0 1 2.11-.45c.83.27 1.7.47 2.59.59A2 2 0 0 1 22 16.92z" />
    </svg>
                <span className="text-center">
                  Kostenloses Erstgespräch
                </span>
              </Link>

              {/* CALENDAR BUTTON */}
              <CalendlyButton text="Strategie-Call vereinbaren" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeConsultation;
